import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Box, Flex } from "@chakra-ui/react";
import '../styles/dsr-display.scss';

import { updateDsrAction } from '../actions/dsr-actions';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';
import LaunchdeckFormTextAreaInput from '../../forms/TextInputField/components/LaunchdeckFormTextAreaInput';
import LaunchdeckModalButtonBar from '../../global/components/helper-components/components/LaunchdeckModalButtonBar';


function EditCategoryForm({
  dsrId,
  mapCategoryId,
  categoryToEdit,
  handleCloseModal,
  // Redux
  createNewDsrActionOutcome,
  // Action
  updateDsrAction
}) {

  const { mapCategoryName, mapCategoryDescription } = categoryToEdit || {};
  const titleCharacterLimit = 100;

  // Input management
  const [categoryInput, setCategoryInput] = useState(mapCategoryName)
  const [mapDescriptionInput, setMapDescriptionInput] = useState(mapCategoryDescription)

  // Validation for required input
  const [showNoCategoryError, setShowNoCategoryError] = useState(false)

  // UX Management
  const [showLoader, setShowLoader] = useState(false)


  const onChangeHandler = (event) => {
    setShowNoCategoryError(false)

    switch (event.target.name) {
      case ('action-category'): {
        setShowNoCategoryError(false)
        setCategoryInput(event.target.value.trim())
        break;
      }
      case ('action-category-description'): {
        setMapDescriptionInput(event.target.value)
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleCloseCreateActionCategoryModal = () => {
    setCategoryInput("")
    setMapDescriptionInput("")

    handleCloseModal()
  }

  const handleEditCategory = () => {

    if (categoryInput.trim().length < 1) {
      setShowNoCategoryError(true)
    } else {
      const updateActionMetadata = {
        dsrId,
        mapCategoryId,
        mapCategoryName: categoryInput,
        mapCategoryDescription: mapDescriptionInput,
        event: "update-category"
      }

      setShowLoader(true)
      updateDsrAction(updateActionMetadata)
    }
  }

  useEffect(() => {
    if (createNewDsrActionOutcome) {
      setShowLoader(false)
      handleCloseCreateActionCategoryModal()
    }
  }, [createNewDsrActionOutcome]);


  return (
    <Box w="100%" align="center" py={['1.5em']}>
      <Flex direction='column' w='100%' maxW='35em' px='2em' align='center' gap='2em'>
        <LaunchdeckFormInput
          label='Category name'
          name={'action-category'}
          onChange={onChangeHandler}
          value={categoryInput}
          isRequired={true}
          charLimit={titleCharacterLimit}

          isDisabled={showLoader}
          errorLogic={showNoCategoryError}
          errorMessage={`Provide a name for your Category`}
        />

        <LaunchdeckFormTextAreaInput
          label="Category description"
          name="action-category-description"
          onChange={onChangeHandler}
          value={mapDescriptionInput}
          charLimit={300}
          showIsOptional={true}
          isDisabled={showLoader}
        />
      </Flex>

      <LaunchdeckModalButtonBar
        fontSize='1em'
        loadingLogic={showLoader}
        ctaFunction={handleEditCategory}
        ctaLabel='Save edit'
        noCancelOption={true}
      />
    </Box>
  )
  
}


function mapStateToProps(state) {
  return {
    updateDsrActionOutcome: state.updateDsrActionOutcome.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsrAction
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditCategoryForm));
